module.exports = __webpack_public_path__ + "img/bounty-score-fill.a5534d82.svg";